import { render, staticRenderFns } from "./PaginationControls.vue?vue&type=template&id=ecfe8a86&scoped=true"
import script from "./PaginationControls.vue?vue&type=script&lang=ts"
export * from "./PaginationControls.vue?vue&type=script&lang=ts"
import style0 from "./PaginationControls.vue?vue&type=style&index=0&id=ecfe8a86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfe8a86",
  null
  
)

export default component.exports